export const durations = {
  ONE_DAY: 60 * 60 * 24,
  ONE_HOUR: 60 * 60,
  ONE_MINUTE: 60,
  ONE_MONTH: 60 * 60 * 24 * 30,
  ONE_SECOND: 1,
  ONE_WEEK: 60 * 60 * 24 * 7,
  ONE_YEAR: 60 * 60 * 24 * 365,
} as const;
